const employeeGlobalSetupInitialState = {
    isEmployeesArchiveHidden: false,
    employeeDisplayOrganizationalPathLength: 0,
    isGlobalSetupDataLoaded: false,
};

export default employeeGlobalSetupInitialState;
